<template>
  <div class="components">
    <NavBar></NavBar>
    <main
      property="mainContentOfPage"
      class="container"
      typeof="WebPageElement"
    >
      <Breadcrumb></Breadcrumb>
      <section class="custom-section">
        <div class="columns">
          <div class="column is-7">
            <h1 class="title is-2">{{ $t("widget_catalogue.title") }}</h1>
            <p class="large-text">
              {{ $t("widget_catalogue.text_1") }}
            </p>
          </div>
          <div class="column is-5">
            <StatusBox />
          </div>
        </div>
        <div class="columns">
          <!-- term of service -->
          <div class="column is-12">
            <p class="is-size-5 pb-2">
              {{ $t("term_service.term_please_read") }}
            </p>
            <b-collapse
              :open="false"
              position="is-bottom"
              aria-id="contentIdForA11y4"
            >
              <template #trigger="props">
                <a
                  class="is-size-5"
                  aria-controls="contentIdForA11y4"
                  :aria-expanded="props.open"
                >
                  {{
                    !props.open
                      ? $t("term_service.term_service_title")
                      : $t("message.close_btn")
                  }}
                  <b-icon
                    :icon="!props.open ? 'caret-down' : 'caret-up'"
                  ></b-icon>
                </a>
              </template>
              <div class="mb-2">
                <p>
                  {{ $t("term_service.term_service_paragraph") }}
                </p>
                <ol class="term">
                  <li
                    class="term-item"
                    v-html="$t('term_service.term_service_text_1')"
                  ></li>
                  <li
                    class="term-item"
                    v-html="$t('term_service.term_service_text_2')"
                  ></li>
                  <li
                    class="term-item"
                    v-html="$t('term_service.term_service_text_3')"
                  ></li>
                  <li
                    class="term-item"
                    v-html="$t('term_service.term_service_text_4')"
                  ></li>
                  <li
                    class="term-item"
                    v-html="$t('term_service.term_service_text_5')"
                  ></li>
                  <li v-html="$t('term_service.term_service_text_6')"></li>
                </ol>
              </div>
            </b-collapse>
          </div>
        </div>
      </section>
      <section class="custom-section">
        <!-- self-identification widgets -->
        <div class="columns">
          <div class="column is-12">
            <h2 class="subtitle is-3">
              {{ $t("widget_catalogue.subtitle_1") }}
            </h2>
            <p class="is-size-5">
              {{ $t("widget_catalogue.text_2") }}
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <!-- sgc widget -->
            <div class="columns is-vcentered">
              <div class="column is-8">
                <router-link
                  class="widget-link"
                  :to="{
                    name: 'widget-details',
                    params: { id: '1' }
                  }"
                >
                  {{ $t("widget_catalogue.sgc_link") }}
                </router-link>
                <p class="widget-subtitle">
                  <b>{{ $t("widget_catalogue.standard") }}</b>
                  {{ $t("widget_catalogue.sgc_subtitle") }}
                </p>
                <p v-html="$t('widget_catalogue.sgc_text')"></p>
                <br />
              </div>
              <div class="column auto">
                <div v-if="$i18n.locale == 'fr'">
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Exemple pour Emplacement"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/location_example_fr.jpg"
                        width="300"
                        height="300"
                        alt="Exemple pour Emplacement"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                </div>
                <div v-else>
                  <figure class="widget-teaser-s">
                    <b-tooltip label="Location example" position="is-bottom">
                      <img
                        src="../../public/images/location_example_en.jpg"
                        width="250"
                        height="250"
                        alt="Location example"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                  <br />
                </div>
              </div>
            </div>
            <!-- naics widget -->
            <div class="columns is-vcentered">
              <div class="column is-8">
                <router-link
                  class="widget-link"
                  :to="{
                    name: 'widget-details',
                    params: { id: '2' }
                  }"
                >
                  {{ $t("widget_catalogue.naics_link") }}
                </router-link>
                <p class="widget-subtitle">
                  <b>{{ $t("widget_catalogue.standard") }}</b>
                  {{ $t("widget_catalogue.naics_subtitle") }}
                </p>
                <p v-html="$t('widget_catalogue.naics_text')"></p>
              </div>
              <div class="column auto">
                <div v-if="$i18n.locale == 'fr'">
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Exemple pour Industrie"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/industry_example_fr.jpg"
                        alt="Exemple pour Industrie"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                </div>
                <div v-else>
                  <figure class="widget-teaser-s">
                    <b-tooltip label="Industry example" position="is-bottom">
                      <img
                        src="../../public/images/industry_example_en.jpg"
                        alt="Industry example"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                  <br />
                </div>
              </div>
            </div>
            <!-- naics tree widget -->
            <div class="columns is-vcentered">
              <div class="column is-8">
                <router-link
                  class="widget-link"
                  :to="{
                    name: 'widget-details',
                    params: { id: '4' }
                  }"
                >
                  {{ $t("widget_catalogue.naics_tree_link") }}
                </router-link>
                <p class="widget-subtitle">
                  <b>{{ $t("widget_catalogue.standard") }}</b>
                  {{ $t("widget_catalogue.naics_subtitle") }}
                </p>
                <p v-html="$t('widget_catalogue.naics_tree_text')"></p>
              </div>
              <div class="column auto">
                <div v-if="$i18n.locale == 'fr'">
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Exemple pour Industrie - Étendu"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/naics-tree_example_fr.jpg"
                        alt="Exemple pour Industrie - Étendu"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                </div>
                <div v-else>
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Industry - Expanded example"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/naics-tree_example_en.jpg"
                        alt="Industry - Expanded example"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                  <br />
                </div>
              </div>
            </div>
            <!-- naics 2022 tree widget -->
            <div class="columns is-vcentered">
              <div class="column is-8">
                <a href="https://beta.dev.openservices.ca/widget_details/7" class="widget-link">{{ $t($t("widget_catalogue.naics2022_tree_link")) }}</a>
                <b-tag class="link-tag" type="is-success">
                  {{ $t("message.new") }}
                </b-tag>
                <p class="widget-subtitle">
                  <b>{{ $t("widget_catalogue.standard") }}</b>
                  {{ $t("widget_catalogue.naics_subtitle") }}
                </p>
                <p v-html="$t('widget_catalogue.naics_tree_text')"></p>
              </div>
              <div class="column auto">
                <div v-if="$i18n.locale == 'fr'">
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Exemple pour Industrie - Étendu"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/naics-tree_example_fr.jpg"
                        alt="Exemple pour Industrie - Étendu"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                </div>
                <div v-else>
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Industry - Expanded example"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/naics-tree_example_en.jpg"
                        alt="Industry - Expanded example"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                  <br />
                </div>
              </div>
            </div>
            <!-- BET widget -->
            <div class="columns is-vcentered">
              <div class="column is-8">
                <router-link
                  class="widget-link"
                  :to="{
                    name: 'widget-details',
                    params: { id: '5' }
                  }"
                >
                  {{ $t("widget_catalogue.BET_link") }}
                </router-link>
                <p v-html="$t('widget_catalogue.BET_text')"></p>
              </div>
              <div class="column auto">
                <div v-if="$i18n.locale == 'fr'">
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Exemple pour Assistant de structures d'entreprise"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/BET_example_fr.png"
                        width="250"
                        height="250"
                        alt="Exemple pour Assistant de structures d'entreprise"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                </div>
                <div v-else>
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Business Structures Wizard example"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/BET_example_en.png"
                        width="250"
                        height="250"
                        alt="Business Structures Wizard example"
                        class="img-is-rounded"
                      />
                    </b-tooltip>
                  </figure>
                  <br />
                </div>
              </div>
            </div>
            <!-- BBF widget -->
            <!--
            <div class="columns is-vcentered">
              <div class="column is-8">
                <router-link
                  class="widget-link"
                  :to="{
                    name: 'widget-details',
                    params: { id: '6' }
                  }"
                >
                  {{ $t("widget_catalogue.BBF_link") }}
                </router-link>
                <b-tag class="link-tag" type="is-success">
                  {{ $t("message.new") }}
                </b-tag>
                <p v-html="$t('widget_catalogue.BBF_text')"></p>
              </div>
              <div class="column auto">
                <div v-if="$i18n.locale == 'fr'">
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Exemple pour Outil de recherche d'aide aux entreprises"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/BBF_example_fr.png"
                        width="250"
                        height="250"
                        alt="Exemple pour Outil de recherche d'aide aux entreprises"
                        class="img-is-rounded mrgn-bttm-sm"
                      />
                    </b-tooltip>
                  </figure>
                </div>
                <div v-else>
                  <figure class="widget-teaser-s">
                    <b-tooltip
                      label="Business Benefit Finder example"
                      position="is-bottom"
                    >
                      <img
                        src="../../public/images/BBF_example_en.png"
                        alt="Business Benefit Finder example"
                        class="img-is-rounded"
                      />
                    </b-tooltip>
                  </figure>
                  <br />
                </div>
              </div>
            </div>
            -->
          </div>
        </div>
      </section>
    </main>
    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import BaseFooter from "@/components/Footer.vue";
import StatusBox from "@/components/StatusBox.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  name: "components",
  props: {
    clickable: {
      type: String
    }
  },
  components: {
    StatusBox,
    NavBar,
    Breadcrumb,
    BaseFooter
  },
  created() {
    document.title = this.$t("open_services.widgets.btn");
  },
  updated() {
    document.title = this.$t("open_services.widgets.btn");
  }
};
</script>
<style lang="scss">
.link-tag {
  margin-left: 12px;
}
table,
th,
td {
  border: 1px solid black;
}
th,
td {
  padding: 15px;
  text-align: center;
}
.image .widget-image-s {
  max-width: 240px;
  max-height: 240px;
}
/* teaser image css */
.widget-teaser-s {
  position: relative;
  max-height: 240px;
  max-width: 240px;
  min-height: 200px;
  min-width: 200px;
}
.widget-teaser-s img {
  border-radius: 100%;
  width: 100%;
  height: auto;
}
.widget-teaser-s::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  box-shadow: inset 20px 20px 30px rgba(0, 0, 0, 0.09),
    inset -16px -16px 20px rgba(0, 0, 0, 0.04);
}
</style>
